import React, { useEffect, useReducer, useRef, useState } from "react";
import { View, Text, TextInput, ActivityIndicator, Dimensions } from "react-native";

// import { DatePicker } from "@s77rt/react-native-date-picker";  // https://www.npmjs.com/package/@s77rt/react-native-date-picker?activeTab=readme
import DateTimePicker, { useDefaultStyles as dtpUseDefaultStyles } from "react-native-ui-datepicker";  // https://www.npmjs.com/package/react-native-ui-datepicker
import { Feather } from "@react-native-vector-icons/feather";
import { FontAwesomeIcon } from "@fortawesome/react-native-fontawesome";
import { faLocationDot, faPaperclip, faPaw, faPhone, faUser} from "@fortawesome/free-solid-svg-icons";  // 'paperclip' is being used from the 'Feather' icons.
// import { ? } from "@fortawesome/free-regular-svg-icons";
import Picker from "components/Partials/Picker";
import Anchor from "components/Partials/Anchor";
import Button from "components/Partials/Buttons";
import { deepCopy, stateReducer } from "components/helpers/stateReducer";
import { Menu, MenuOptions, MenuOption, MenuTrigger } from "react-native-popup-menu";  // https://www.npmjs.com/package/react-native-popup-menu
import * as SideScreens from "components/Views/SideScreens/Index";
import { openSideScreen } from "components/Views/SideScreens/SideScreenLoader";

const Schedule = () => {
  const _theme = window.main.theme;
  const userProfile = window.main.lib.getUserProfile();

  const [loadingData, setLoadingData] = useState(false);

  const [schedulesViewState, schedulesViewSetState] = useReducer(stateReducer, {
    appointmentTypes: [],
    schedulesList: [],
    scheduleConfigData: {},
    appointmentsData: [],
    initComplete: false,
    selectedScheduleId: 0,
    selectedGroupId: 0,
    selectedResourceId: 0,
    selectedScheduleDate: (new Date(new Date().setHours(0,0,0,0))),
  });

  const [datePickerOpenState, datePickerOpenSetState] = useState(false);
  const toggleDatePickerOpen = ()=>{
    apptDateInputRef.current.blur();
    datePickerOpenSetState(prev=>(!prev));
  };

  const initialDataLoad = async () => {
    try {
      window.main.lib.setLoadingState(true);
      const _stateProps = [
        { key: "initComplete", type: "boolean", initComplete: true }
      ];
      const [schedulesResp] = await Promise.all([
        window.main.axios.get(window.main.api.getSchedules),
      ]);
      if (!!schedulesResp && !schedulesResp.data) {
        throw schedulesResp;
      }
      _stateProps.push({ key: "schedulesList", type: "array", schedulesList: schedulesResp.data });
      if (!!schedulesResp.data.length && !!Number(schedulesResp.data[0].schedule_id)) {
        // Default to selecting the first schedule_id in the result: schedulesResp.data[0].schedule_id
        _stateProps.push({ key: "selectedScheduleId", type: "number", selectedScheduleId: Number(schedulesResp.data[0].schedule_id) });
        const _schedule_details = await window.main.axios.get(window.main.api.getScheduleConfig.replace("{schedule_id}",schedulesResp.data[0].schedule_id));
        // Store the selected 'scheduleConfigData'.
        _stateProps.push({ key: "scheduleConfigData", type: "object", scheduleConfigData: _schedule_details.data });
        // Loop through all groups & resources to find a matching name for *this* logged-in user.
        //  If found, select that group and resource.
        //  There is a 'useEffect' farther below that will auto-load the scheduled appointments.
        groupsLoop: for (const groupObj of _schedule_details.data.groups) {
          for (const resourceObj of groupObj.resources) {
            if (resourceObj) {
              if (!!resourceObj.resource_name && resourceObj.resource_name.includes(userProfile.first_name+" "+userProfile.last_name)) {
                _stateProps.push({ key: "selectedGroupId", type: "number", selectedGroupId: Number(groupObj.group_id) });
                _stateProps.push({ key: "selectedResourceId", type: "number", selectedResourceId: Number(resourceObj.resource_id) });
                break groupsLoop;
              }
            }
          }
        }
        // DEBUGGING: RESET TO QUICK SETTINGS:
        // _stateProps.length = 0;
        // _stateProps.push(
        //   { key: "initComplete", type: "boolean", initComplete: true },
        //   { key: "schedulesList", type: "array", schedulesList: schedulesResp.data },
        //   { key: "selectedScheduleId", type: "number", selectedScheduleId: Number(schedulesResp.data[0].schedule_id) },
        //   { key: "scheduleConfigData", type: "object", scheduleConfigData: _schedule_details.data },
        //   { key: "selectedGroupId", type: "number", selectedGroupId: 1 },
        //   { key: "selectedResourceId", type: "number", selectedResourceId: 3 },
        //   { key: "selectedScheduleDate", type: "date", selectedScheduleDate: new Date("2026-10-08T00:00:00") }
        // );
      }
      // Update all states at once:
      schedulesViewSetState(_stateProps);
    } catch (err) {
      const errMsg = window.main.lib.parseErrorMessage(err);
      window.main.lib.setStatusState("Error: "+errMsg);
    } finally {
      window.main.lib.setLoadingState(false);
    }
  };

  const onChangeSelectSchedule = async (val)=>{
    schedulesViewSetState([
      { key: "selectedScheduleId", type: "number", selectedScheduleId: Number(val) },
    ]);
    // Load the config data for the selected schedule:
    try {
      setLoadingData(true);
      const _stateProps = [];
      const [scheduleConfigResp] = await Promise.all([
        window.main.axios.get(window.main.api.getScheduleConfig.replace("{schedule_id}",val)),
      ]);
      if (!!scheduleConfigResp && !scheduleConfigResp.data) {
        throw scheduleConfigResp;
      }
      _stateProps.push({ key: "scheduleConfigData", type: "object", scheduleConfigData: scheduleConfigResp.data });
      // Update all states at once:
      schedulesViewSetState(_stateProps);
    } catch (err) {
      const errMsg = window.main.lib.parseErrorMessage(err);
      window.main.lib.setStatusState("Error: "+errMsg);
    } finally {
      setLoadingData(false);
    }
  };
  const onChangeSelectGroup = (val)=>{
    schedulesViewSetState([
      { key: "selectedGroupId", type: "number", selectedGroupId: Number(val) },
    ]);
  };
  const onChangeSelectResource = (val)=>{
    schedulesViewSetState([
      { key: "selectedResourceId", type: "number", selectedResourceId: Number(val) },
    ]);
  };
  const handleDateSelection = (obj) => {
    schedulesViewSetState([
      { key: "selectedScheduleDate", type: "date", selectedScheduleDate: new Date(obj.date) },
    ]);
    datePickerOpenSetState(false);  // Close date picker after selected.
  };
  const handleDateBackward = () => {
    const _yesterday = new Date(schedulesViewState.selectedScheduleDate); _yesterday.setDate(_yesterday.getDate()-1);
    schedulesViewSetState([
      { key: "selectedScheduleDate", type: "date", selectedScheduleDate: _yesterday },
    ]);
    datePickerOpenSetState(false);  // Close date picker after selected.
  };
  const handleDateForward = () => {
    const _tomorrow = new Date(schedulesViewState.selectedScheduleDate); _tomorrow.setDate(_tomorrow.getDate()+1);
    schedulesViewSetState([
      { key: "selectedScheduleDate", type: "date", selectedScheduleDate: _tomorrow },
    ]);
    datePickerOpenSetState(false);  // Close date picker after selected.
  };

  const loadScheduledAppointments = async (obj) => {
    if (!Number(schedulesViewState.selectedResourceId) || !schedulesViewState.selectedScheduleDate) {
      return false;
    }
    // Load the scheduled appointments on the selected date:
    try {
      const _server_date = schedulesViewState.selectedScheduleDate.toISOString().split("T")[0];
      setLoadingData(true);
      const _stateProps = [];
      const [apptsResp] = await Promise.all([
        // /:schedule_id/resource/:resource_id/date/:date
        window.main.axios.get(window.main.api.getScheduleDateAppts.replace("{schedule_id}",schedulesViewState.selectedScheduleId).replace("{group_id}",schedulesViewState.selectedGroupId).replace("{resource_id}",schedulesViewState.selectedResourceId).replace("{schedule_date}",_server_date)),
      ]);
      if (!!apptsResp && !apptsResp.data) {
        throw apptsResp;
      } else {
        _stateProps.push({ key: "appointmentsData", type: "array", appointmentsData: apptsResp.data });
      }
      // Update all states at once:
      schedulesViewSetState(_stateProps);
    } catch (err) {
      const errMsg = window.main.lib.parseErrorMessage(err);
      window.main.lib.setStatusState("Error: "+errMsg);
    } finally {
      setLoadingData(false);
    }
  };

  // Auto-reload Schedule Data whenever either of these two values change:
  useEffect(() => {
    if (!!Number(schedulesViewState.selectedResourceId) && !!schedulesViewState.selectedScheduleDate) {
      loadScheduledAppointments();
    }
  }, [schedulesViewState.selectedResourceId, schedulesViewState.selectedScheduleDate]);  // ⬅ Trigger only once on initial page load.

  useEffect(() => {
    initialDataLoad();
    // ⬇ Debugging: Uncomment this to quickly auto-load a client details sidescreen:
    // window.setTimeout(()=>{
    //   openSideScreen("client",{client_id:10183});
    // },1000);
    // window.setTimeout(()=>{
    //   // openSideScreen("patient",{client_id:207,patient_id:25068});
    //   openSideScreen("patient",{client_id:10344,patient_id:18494});
    // },1500);
    // window.setTimeout(()=>{
    //   openSideScreen("visit",{client_id:10344,patient_id:18494,visit_id:171848});
    //   // openSideScreen("visit",{client_id:207,patient_id:25068,visit_id:176332});
    // },1500);
    // window.setTimeout(()=>{
    //   // openSideScreen("invoice",{invoice_id:279534});
    //   openSideScreen("invoice",{invoice_id:236191});
    // },1500);
  }, []);  // ⬅ Trigger only once on initial page load.

  const dtpStyles = dtpUseDefaultStyles();
  // dtpStyles.day_cell.minHeight = 35;

  const apptDateInputRef = useRef();
  const apptCommonTextStyle = {fontWeight:"400",fontSize:16,lineHeight:20,color:_theme.colors.mode.textColor4,marginBottom:4};
  const faIconStyle = {color:_theme.colors.mode.textColor4,height:16,width:16,marginBottom:-2,marginRight:5};
  const { height, width } = Dimensions.get("window");
  const _scheduleFormInput = { ..._theme.pickerInput, fontSize:18, paddingHorizontal:10, paddingBottom:5, paddingTop:6 };
  const _scheduleFormDateInput = { ..._theme.textInput, fontSize:18, paddingHorizontal:13, paddingBottom:5, paddingTop:6, flexGrow:1 };
  const _scheduleFormDateButton = { ..._theme.textInput, width:"auto", paddingHorizontal:13, marginVertical:0 };

  return (
    <View id="schedule_view" style={{display:"flex",flexDirection:"column",flexGrow:1,flexShrink:1,height:(height-60),alignItems:"stretch",justifyContent:"flex-start",paddingTop:6}}>

      {!window.main.lib.getLoadingState() &&

        <>
          <View style={{flexDirection:"column",flexGrow:0,flexShrink:0,rowGap:6,paddingBottom:6,paddingTop:1,paddingHorizontal:6,borderBottomWidth:5,borderBottomColor:_theme.colors.accentDark,zIndex:2}}>

            <View style={{display:"flex",flexDirection:"column",flexGrow:1}}>
              <Picker selectedValue={schedulesViewState.selectedScheduleId} onValueChange={onChangeSelectSchedule} style={{..._scheduleFormInput, borderWidth:0}}>
                <Picker.Item label="-- Select Schedule --" value="0" />
                {schedulesViewState.schedulesList.filter(o=>(o.location_id===Number(userProfile.current_location.location_id))).map(o => (
                  <Picker.Item key={`schedule_id_${o.schedule_id}`} label={o.schedule_name} value={o.schedule_id} />
                ))}
              </Picker>
            </View>

            <View style={{display:"flex",flexDirection:"column",flexGrow:1}}>
              <Picker selectedValue={schedulesViewState.selectedGroupId} onValueChange={onChangeSelectGroup} style={_scheduleFormInput} disabled={!schedulesViewState.selectedScheduleId}>
                <Picker.Item label="-- Select Group --" value="0" />
                {!!schedulesViewState.scheduleConfigData.groups && schedulesViewState.scheduleConfigData.groups.map(o => (
                  <Picker.Item key={`group_id_${o.group_id}`} label={o.group_name} value={o.group_id} />
                ))}
              </Picker>
            </View>

            <View style={{display:"flex",flexDirection:"column",flexGrow:1}}>
              <Picker selectedValue={schedulesViewState.selectedResourceId} onValueChange={onChangeSelectResource} style={_scheduleFormInput} disabled={!schedulesViewState.selectedGroupId}>
                <Picker.Item label="-- Select Resource --" value="0" />
                {!!schedulesViewState.scheduleConfigData.groups && schedulesViewState.scheduleConfigData.groups.find(o=>(o.group_id===schedulesViewState.selectedGroupId))?.resources.map(o => (
                  <Picker.Item key={`resource_id_${o.resource_id}`} label={o.resource_name} value={o.resource_id} />
                ))}
              </Picker>
            </View>

            <View style={{display:"flex",flexDirection:"column",flexGrow:1,zIndex:10}}>
              <View style={{display:"flex",flexDirection:"row",flexGrow:1,columnGap:6}}>
                <TextInput ref={apptDateInputRef} value={(new Date(schedulesViewState.selectedScheduleDate)).toString()!=="Invalid Date" ? window.main.lib.dateFormat(schedulesViewState.selectedScheduleDate) : ""} placeholder="-- Select Date --" onFocus={toggleDatePickerOpen} editable={false} style={_scheduleFormDateInput} />
                <Button type="secondary" text="" ficon="chevron-left" onPress={handleDateBackward} style={_scheduleFormDateButton} />
                <Button type="secondary" text="" ficon="chevron-right" onPress={handleDateForward} style={_scheduleFormDateButton} />
              </View>
              {!!datePickerOpenState &&
                <View style={{position:"relative",width:"100%"}}>
                  <View style={{position:"absolute",top:0,left:0,backgroundColor:"#ffffff",borderRadius:_theme.borderRadius,...window.main.theme.boxShadowStyle}}>
                    <DateTimePicker mode="single" date={(new Date(schedulesViewState.selectedScheduleDate)).toString()!=="Invalid Date" ? window.main.lib.dateFormat(schedulesViewState.selectedScheduleDate) : undefined} onChange={handleDateSelection} styles={dtpStyles} />
                  </View>
                </View>
              }
            </View>

          </View>

          <View style={{display:"flex",flexDirection:"column",flexGrow:1,flexShrink:1,flexBasis:"0%",alignItems:"stretch",justifyContent:"flex-start",overflow:"auto",rowGap:5,zIndex:1,borderBottomWidth:5,borderBottomColor:_theme.colors.accentDark}}>

            {(!schedulesViewState.appointmentsData || !schedulesViewState.appointmentsData.length) &&
              <>
                {(!schedulesViewState.selectedGroupId || !schedulesViewState.selectedScheduleDate) &&
                  <View style={{padding:12}}><Text style={{textAlign:"center",zIndex:1}}>Please select the fields above.</Text></View>
                }
                {(!!schedulesViewState.selectedGroupId && !!schedulesViewState.selectedScheduleDate) &&
                  <View style={{padding:12}}><Text style={{textAlign:"center",zIndex:1}}>There are no appointments to display.</Text></View>
                }
              </>
            }
            {/* {!!schedulesViewState.appointmentsData && !!schedulesViewState.appointmentsData.length && */}
            {!!schedulesViewState.appointmentsData && !!schedulesViewState.appointmentsData.length && schedulesViewState.appointmentsData.map((apptObj)=>{
              return (
                <View key={`appt_${apptObj.id}`} style={{..._theme.tileRow,minHeight:140}}>

                  <AppointmentSubmenu menuData={apptObj} />

                  <View style={{maxWidth:"92%"}}>
                    <Text style={{fontSize:22,fontWeight:"600",paddingBottom:5}}>{apptObj.title}</Text>
                  </View>

                  <View>
                    <Text style={{...apptCommonTextStyle,fontWeight:"200",paddingBottom:5}}>{window.main.lib.dateTimeRangeFormat(apptObj.start_date.replace(/Z$/,""), apptObj.end_date.replace(/Z$/,""))} {window.main.lib.dateRangeDurationStr(apptObj.start_date.replace(/Z$/,""), apptObj.end_date.replace(/Z$/,""))}</Text>
                  </View>
                  <View style={{position:"relative",display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
                    <Text style={{...apptCommonTextStyle}}><FontAwesomeIcon style={faIconStyle} icon={faUser} />{apptObj.client.title}</Text>
                    <Text style={{...apptCommonTextStyle}}><FontAwesomeIcon style={faIconStyle} icon={faPaw} />{apptObj.patient.name}</Text>
                  </View>
                  {!!apptObj.client.contact.phone_1 &&
                    <View>
                      <Text style={{...apptCommonTextStyle}}><FontAwesomeIcon style={{...faIconStyle,marginLeft:1}} icon={faPhone} /><Anchor phoneNumber={apptObj.client.contact.phone_1}>{window.main.lib.phoneFormat(apptObj.client.contact.phone_1)}</Anchor></Text>
                    </View>
                  }
                  <View style={{flexDirection:"row",marginLeft:-2}}>
                    <FontAwesomeIcon icon={faLocationDot} style={{...faIconStyle,marginLeft:2}} />
                    <Text style={{...apptCommonTextStyle,display:"block"}}>
                      <Anchor style={{whiteSpace:"pre-line"}} mapAddress={apptObj.location.address_1+(!!apptObj.location.address_2 ? ' '+apptObj.location.address_2:'')+', '+apptObj.location.city+', '+apptObj.location.state+' '+apptObj.location.zip}>{!!apptObj.location.name && apptObj.location.name+"\n"}{apptObj.location.address_1}{!!apptObj.location.address_2 && " "+apptObj.location.address_2}{"\n"}{apptObj.location.city}, {apptObj.location.state} {apptObj.location.zip}
                      </Anchor>
                    </Text>
                  </View>
                  {!!apptObj.notes &&
                    <View style={{flexDirection:"row"}}>
                      <Text style={{...apptCommonTextStyle}}>
                        {/* <Feather name="paperclip" style={{...faIconStyle}} /> */}
                        <FontAwesomeIcon style={faIconStyle} icon={faPaperclip} />
                      </Text>
                      <Text style={{...apptCommonTextStyle,display:"block"}}>
                        {apptObj.notes}
                      </Text>
                    </View>
                  }
                </View>
              );
            })}
            {/* } */}
          </View>

        </>

      }
      {!window.main.lib.getLoadingState() && loadingData &&
        <View style={{zIndex:99999, backgroundColor:"rgba(255,255,255,0.7)", top:0, left:0, bottom:0, right:0, position:(window.main.platform_os==="web"?"fixed":"absolute")}}>
          <ActivityIndicator size="large" color={_theme.colors.mode.base} style={{marginTop:20}} />
        </View>
      }

    </View>
  );
};

// Helpers

const AppointmentSubmenu = ({menuData})=>{
  const _theme = window.main.theme;
  const _menuRef = useRef();
  const menuSideScreens = {};
  if (!!SideScreens.client && !!SideScreens.client.key) {
    menuSideScreens.client = deepCopy(SideScreens.client);
    menuSideScreens.client.onPress = () => {
      openSideScreen("client", {client_id:menuData.client_id});  // client_id must always exist for layer-validation
      _menuRef.current?.close();
    }
  };
  if (!!SideScreens.patient && !!SideScreens.patient.key) {
    menuSideScreens.patient = deepCopy(SideScreens.patient);
    menuSideScreens.patient.onPress = () => {
      openSideScreen("patient", {client_id:menuData.client_id, patient_id:menuData.patient_id});  // client_id must always exist for layer-validation
      _menuRef.current?.close();
    }
  };
  // if (!!SideScreens.checkin && !!SideScreens.checkin.key && !Number(menuData.visit_id)) {
  //   menuSideScreens.checkin = deepCopy(SideScreens.checkin);
  //   menuSideScreens.checkin.onPress = () => {
  //     openSideScreen("checkin", {client_id:menuData.client_id, apptObj:menuData});  // client_id must always exist for layer-validation
  //     _menuRef.current?.close();
  //   }
  // };
  if (!!SideScreens.visit && !!SideScreens.visit.key && !!Number(menuData.visit_id)) {
    menuSideScreens.visit = deepCopy(SideScreens.visit);
    menuSideScreens.visit.onPress = () => {
      openSideScreen("visit", {client_id:menuData.client_id, patient_id:menuData.patient_id, visit_id:menuData.visit_id});  // client_id must always exist for layer-validation
      _menuRef.current?.close();
    }
  };
  if (!!SideScreens.assessment && !!SideScreens.assessment.key && !!Number(menuData.assessment_id)) {
    menuSideScreens.assessment = deepCopy(SideScreens.assessment);
    menuSideScreens.assessment.onPress = () => {
      openSideScreen("assessment", {client_id:menuData.client_id, apptObj:menuData});  // client_id must always exist for layer-validation
      _menuRef.current?.close();
    }
  };
  if (!!SideScreens.billing && !!SideScreens.billing.key) {
    menuSideScreens.billing = deepCopy(SideScreens.billing);
    menuSideScreens.billing.onPress = () => {
      openSideScreen("billing", {client_id:menuData.client_id});  // client_id must always exist for layer-validation
      _menuRef.current?.close();
    }
  };

  return (
    <Menu ref={_menuRef} style={{position:"absolute",top:8,right:8,marginHorizontal:0,zIndex:1010}}>
      <MenuTrigger customStyles={_theme.rnpmMenuTrigger}><Feather name="more-vertical" style={{..._theme.moreMenuButton,..._theme.moreMenuButtonIcon,fontSize:22,lineHeight:30,textAlign:"center"}} /></MenuTrigger>
      <MenuOptions customStyles={_theme.rnpmMenuOptions}>
        {Object.keys(menuSideScreens).map((key)=>{
          const viewObj = menuSideScreens[key];
          const RenderIcon = (()=>{
            if (!!viewObj.iconSource && viewObj.iconSource==="fa" && typeof(viewObj.icon)==="object") {
              return (<FontAwesomeIcon icon={viewObj.icon} style={{color:_theme.colors.mode.textColor4,height:14,width:14,marginBottom:1,marginRight:6,marginLeft:0}} />);
            }  // Else:
            return (<Feather name={viewObj.icon} size={14} style={{color:_theme.colors.mode.textColor4,marginBottom:1,marginRight:6,marginLeft:1}} />);
          })();  // ⬅ Immediate evaluation before passing into 'MoreMenuItem'.
          return (
            <MenuOption key={viewObj.title} id={`moremenu_${key}`} onPress={viewObj.onPress} customStyles={_theme.rnpmMenuOption}>
              <Text style={_theme.rnpmMenuOptionText}>
                {!!viewObj.iconSource && viewObj.iconSource==="fa" && typeof(viewObj.icon)==="object" &&
                  <FontAwesomeIcon icon={viewObj.icon} style={_theme.rnpmMenuOptionIcon} />
                }
                {!(!!viewObj.iconSource && viewObj.iconSource==="fa" && typeof(viewObj.icon)==="object") && !!viewObj.icon &&
                  <Feather name={viewObj.icon} size={_theme._theme.rnpmMenuOptionIcon.fontSize} style={{..._theme._theme.rnpmMenuOptionIcon,marginLeft:1}} />
                }
                {viewObj.title}
              </Text>
            </MenuOption>
          );
        })}
      </MenuOptions>
    </Menu>
  );
};

export default Schedule;
